module.exports = __webpack_public_path__ + "img/update-icon.45339cb2.png";